export default {
  CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_FETCH_REQUEST:
    'CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_FETCH_REQUEST',
  CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_FETCH_SUCCESS:
    'CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_FETCH_SUCCESS',
  CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_FETCH_ERROR:
    'CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_FETCH_ERROR',

  CONFIGURATION_FIELDS_GET_LIST_MANAGER_FORM_MODELS_FETCH_REQUEST:
    'CONFIGURATION_FIELDS_GET_LIST_MANAGER_FORM_MODELS_FETCH_REQUEST',
  CONFIGURATION_FIELDS_GET_LIST_MANAGER_FORM_MODELS_FETCH_SUCCESS:
    'CONFIGURATION_FIELDS_GET_LIST_MANAGER_FORM_MODELS_FETCH_SUCCESS',
  CONFIGURATION_FIELDS_GET_LIST_MANAGER_FORM_MODELS_FETCH_ERROR:
    'CONFIGURATION_FIELDS_GET_LIST_MANAGER_FORM_MODELS_FETCH_ERROR',

  CONFIGURATION_FIELDS_CREATE_FORM_EMPTY_FETCH_REQUEST:
    'CONFIGURATION_FIELDS_CREATE_FORM_EMPTY_FETCH_REQUEST',
  CONFIGURATION_FIELDS_CREATE_FORM_EMPTY_FETCH_SUCCESS:
    'CONFIGURATION_FIELDS_CREATE_FORM_EMPTY_FETCH_SUCCESS',
  CONFIGURATION_FIELDS_CREATE_FORM_EMPTY_FETCH_ERROR:
    'CONFIGURATION_FIELDS_CREATE_FORM_EMPTY_FETCH_ERROR',

  CONFIGURATION_FIELDS_POST_DRAFT_FETCH_REQUEST:
    'CONFIGURATION_FIELDS_POST_DRAFT_FETCH_REQUEST',
  CONFIGURATION_FIELDS_POST_DRAFT_FETCH_SUCCESS:
    'CONFIGURATION_FIELDS_POST_DRAFT_FETCH_SUCCESS',
  CONFIGURATION_FIELDS_POST_DRAFT_FETCH_ERROR:
    'CONFIGURATION_FIELDS_POST_DRAFT_FETCH_ERROR',

  CONFIGURATION_FIELDS_GET_LIST_DRAFTS_FETCH_REQUEST:
    'CONFIGURATION_FIELDS_GET_LIST_DRAFTS_FETCH_REQUEST',
  CONFIGURATION_FIELDS_GET_LIST_DRAFTS_FETCH_SUCCESS:
    'CONFIGURATION_FIELDS_GET_LIST_DRAFTS_FETCH_SUCCESS',
  CONFIGURATION_FIELDS_GET_LIST_DRAFTS_FETCH_ERROR:
    'CONFIGURATION_FIELDS_GET_LIST_DRAFTS_FETCH_ERROR',

  CONFIGURATION_EDIT_FORM_MODEL_VERSION_FETCH_REQUEST:
    'CONFIGURATION_EDIT_FORM_MODEL_VERSION_FETCH_REQUEST',
  CONFIGURATION_EDIT_FORM_MODEL_VERSION_FETCH_SUCCESS:
    'CONFIGURATION_EDIT_FORM_MODEL_VERSION_FETCH_SUCCESS',
  CONFIGURATION_EDIT_FORM_MODEL_VERSION_FETCH_ERROR:
    'CONFIGURATION_EDIT_FORM_MODEL_VERSION_FETCH_ERROR',

  FORM_GET_CATEGORIES_MODELS_FETCH_REQUEST_STATUS:
    'FORM_GET_CATEGORIES_MODELS_FETCH_REQUEST_STATUS',
  FORM_GET_CATEGORIES_ALL_FETCH_SUCCESS:
    'FORM_GET_CATEGORIES_ALL_FETCH_SUCCESS',
  SET_CATEGORY_SELECTED_FORM:
    'SET_CATEGORY_SELECTED_FORM',
  SET_FORMS_FILTER_FORM:
    'SET_FORMS_FILTER_FORM',
  FORM_GET_CATEGORIES_FORM_FETCH_SUCCESS:
    'FORM_GET_CATEGORIES_FORM_FETCH_SUCCESS',
  SET_AUTHORS_FORMS:
    'SET_AUTHORS_FORMS',
  SET_SIDEBAR_BUTTON_SELECT_FORM:
    'SET_SIDEBAR_BUTTON_SELECT_FORM',
  SET_FAVORITES_FORM_MODELS:
    'SET_FAVORITES_FORM_MODELS',
  SET_FAVORITES_FORM_SELECTED:
    'SET_FAVORITES_FORM_SELECTED',
  MODAL_CONFIGURATION_MEDICALRECORD_SECTIONS_FORMS:
    'MODAL_CONFIGURATION_MEDICALRECORD_SECTIONS_FORMS',
  SAVE_SECTION_FORM_ACCOUNT_CONFIG_FETCH_REQUEST:
    'SAVE_SECTION_FORM_ACCOUNT_CONFIG_FETCH_REQUEST',
  SET_TAB_SELECTED_BUTTON_SELECT_FORM:
    'SET_TAB_SELECTED_BUTTON_SELECT_FORM',

  CONFIGURATION_UPDATE_STATUS_FORM_MODEL_BY_ID_FETCH_REQUEST:
    'CONFIGURATION_UPDATE_STATUS_FORM_MODEL_BY_ID_FETCH_REQUEST',
  CONFIGURATION_UPDATE_STATUS_FORM_MODEL_BY_ID_FETCH_SUCCESS:
    'CONFIGURATION_UPDATE_STATUS_FORM_MODEL_BY_ID_FETCH_SUCCESS',
  CONFIGURATION_UPDATE_STATUS_FORM_MODEL_BY_ID_FETCH_ERROR:
    'CONFIGURATION_UPDATE_STATUS_FORM_MODEL_BY_ID_FETCH_ERROR',

  CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_DELETED_FETCH_REQUEST:
    'CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_DELETED_FETCH_REQUEST',
  CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_DELETED_FETCH_SUCCESS:
    'CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_DELETED_FETCH_SUCCESS',
  CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_DELETED_FETCH_ERROR:
    'CONFIGURATION_FIELDS_GET_LIST_FORM_MODELS_DELETED_FETCH_ERROR',

  CONFIGURATION_UPDATE_STATUS_DRAFT_BY_ID_FETCH_REQUEST:
    'CONFIGURATION_UPDATE_STATUS_DRAFT_BY_ID_FETCH_REQUEST',
  CONFIGURATION_UPDATE_STATUS_DRAFT_BY_ID_FETCH_SUCCESS:
    'CONFIGURATION_UPDATE_STATUS_DRAFT_BY_ID_FETCH_SUCCESS',
  CONFIGURATION_UPDATE_STATUS_DRAFT_BY_ID_FETCH_ERROR:
    'CONFIGURATION_UPDATE_STATUS_DRAFT_BY_ID_FETCH_ERROR',

  CONFIGURATION_FIELDS_GET_LIST_DRAFTS_DELETED_FETCH_REQUEST:
    'CONFIGURATION_FIELDS_GET_LIST_DRAFTS_DELETED_FETCH_REQUEST',
  CONFIGURATION_FIELDS_GET_LIST_DRAFTS_DELETED_FETCH_SUCCESS:
    'CONFIGURATION_FIELDS_GET_LIST_DRAFTS_DELETED_FETCH_SUCCESS',
  CONFIGURATION_FIELDS_GET_LIST_DRAFTS_DELETED_FETCH_ERROR:
    'CONFIGURATION_FIELDS_GET_LIST_DRAFTS_DELETED_FETCH_ERROR',

  PROM_REQUESTS_FETCH_REQUEST: 'PROM_REQUESTS_FETCH_REQUEST',
  PROM_REQUESTS_FETCH_SUCCESS: 'PROM_REQUESTS_FETCH_SUCCESS',
  PROM_REQUESTS_FETCH_ERROR: 'PROM_REQUESTS_FETCH_ERROR',

  PROM_REQUEST_CREATE_FETCH_REQUEST: 'PROM_REQUEST_CREATE_FETCH_REQUEST',
  PROM_REQUEST_CREATE_FETCH_SUCCESS: 'PROM_REQUEST_CREATE_FETCH_SUCCESS',
  PROM_REQUEST_CREATE_FETCH_ERROR: 'PROM_REQUEST_CREATE_FETCH_ERROR',

  PROM_REQUEST_REVIEW_FETCH_REQUEST: 'PROM_REQUEST_REVIEW_FETCH_REQUEST',
  PROM_REQUEST_REVIEW_FETCH_SUCCESS: 'PROM_REQUEST_REVIEW_FETCH_SUCCESS',
  PROM_REQUEST_REVIEW_FETCH_ERROR: 'PROM_REQUEST_REVIEW_FETCH_ERROR',

  PROM_REQUEST_APPROVE_FETCH_REQUEST: 'PROM_REQUEST_APPROVE_FETCH_REQUEST',
  PROM_REQUEST_APPROVE_FETCH_SUCCESS: 'PROM_REQUEST_APPROVE_FETCH_SUCCESS',
  PROM_REQUEST_APPROVE_FETCH_ERROR: 'PROM_REQUEST_APPROVE_FETCH_ERROR',

  PROM_REQUEST_REJECT_FETCH_REQUEST: 'PROM_REQUEST_REJECT_FETCH_REQUEST',
  PROM_REQUEST_REJECT_FETCH_SUCCESS: 'PROM_REQUEST_REJECT_FETCH_SUCCESS',
  PROM_REQUEST_REJECT_FETCH_ERROR: 'PROM_REQUEST_REJECT_FETCH_ERROR',

  SET_PROM_REQUESTS_MODAL_OPEN: 'SET_PROM_REQUESTS_MODAL_OPEN',
  SET_PROM_REQUEST_SELECTED: 'SET_PROM_REQUEST_SELECTED',

  PROM_REQUEST_GET_BY_ID_FETCH_REQUEST: 'PROM_REQUEST_GET_BY_ID_FETCH_REQUEST',
  PROM_REQUEST_GET_BY_ID_FETCH_SUCCESS: 'PROM_REQUEST_GET_BY_ID_FETCH_SUCCESS',
  PROM_REQUEST_GET_BY_ID_FETCH_ERROR: 'PROM_REQUEST_GET_BY_ID_FETCH_ERROR',

  PROM_REQUEST_FORM_FETCH_REQUEST: 'PROM_REQUEST_FORM_FETCH_REQUEST',
  PROM_REQUEST_FORM_FETCH_SUCCESS: 'PROM_REQUEST_FORM_FETCH_SUCCESS',
  PROM_REQUEST_FORM_FETCH_ERROR: 'PROM_REQUEST_FORM_FETCH_ERROR',

  UPDATE_PROM_REQUEST_FORM_FETCH_REQUEST: 'UPDATE_PROM_REQUEST_FORM_FETCH_REQUEST',
  UPDATE_PROM_REQUEST_FORM_FETCH_SUCCESS: 'UPDATE_PROM_REQUEST_FORM_FETCH_SUCCESS',
  UPDATE_PROM_REQUEST_FORM_FETCH_ERROR: 'UPDATE_PROM_REQUEST_FORM_FETCH_ERROR',
};
